import {DrawerProps} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import config from "../config";
import {PipelineRecordFormProps} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & Omit<PipelineRecordFormProps, 'handleCancel'>) => {

    const title = record.id
        ? `Edit ${config.titles.singular}`
        : `New ${config.titles.singular}`

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                // Close only AFTER the mutation resolves. Closing on the same
                // tick discarded the operator's edits whenever the server
                // rejected the write — a duplicate name, a resolver validation
                // failure — and surfaced the error toast over an empty drawer.
                handleSubmit={async (values) => {
                    await handleSubmit(values);
                    onClose();
                }}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};
